module.exports = __webpack_public_path__ + "img/music-background.28fe57ec.jpg";